import React from "react";
import classNames from "classnames";

import Logo from "../logo/Logo";
import "./styles.styl";
import { FormattedMessage } from "react-intl";

export default function Contact(props) {
  const { logoSmallUrl, phoneNumber, companyEmail, className, ...rest } = props;

  return (
    <div className={classNames("contact", className)} {...rest}>
      <Logo className="contact__logo" logoSmallUrl={logoSmallUrl} />
      <p className="contact__text">
        <FormattedMessage id="contactForQuestions" />
      </p>
      <div className="contact__link">
        E-Mail:{" "}
        <a rel="noreferrer" target="_blank" href={`mailto:${companyEmail}`}>
          {companyEmail}
        </a>
      </div>
      <div className="contact__link">
        <FormattedMessage id="telephone" /> :{" "}
        <a rel="noreferrer" target="_blank" href={`tel:${phoneNumber}`}>
          {phoneNumber}
        </a>
      </div>
    </div>
  );
}
